import logo1 from "../../assets/img/historicEvents/LogoIYH/1995_1-6.png";
import logo2 from "../../assets/img/historicEvents/LogoIYH/1996_7-10.png";
import logo11 from "../../assets/img/historicEvents/LogoIYH/1997_11.png";
import logo12 from "../../assets/img/historicEvents/LogoIYH/1997_12.png";
import logo13 from "../../assets/img/historicEvents/LogoIYH/1997_13.png";
import logo14 from "../../assets/img/historicEvents/LogoIYH/1997_14.png";
import logo15 from "../../assets/img/historicEvents/LogoIYH/1997_15.png";
import logo16 from "../../assets/img/historicEvents/LogoIYH/1997_16.png";
import logo17 from "../../assets/img/historicEvents/LogoIYH/1997_17.png";
import logo18 from "../../assets/img/historicEvents/LogoIYH/1997_18.png";
import logo19 from "../../assets/img/historicEvents/LogoIYH/1997_19.png";
import logo20 from "../../assets/img/historicEvents/LogoIYH/1998_20.png";
import logo21 from "../../assets/img/historicEvents/LogoIYH/1998_21.png";
import logo22 from "../../assets/img/historicEvents/LogoIYH/1998_22.png";
import logo23 from "../../assets/img/historicEvents/LogoIYH/1998_23.png";
import logo24 from "../../assets/img/historicEvents/LogoIYH/1998_24.png";
import logo25 from "../../assets/img/historicEvents/LogoIYH/1998_25.png";
import logo26 from "../../assets/img/historicEvents/LogoIYH/1998_26.png";
import logo27 from "../../assets/img/historicEvents/LogoIYH/1999_27.png";
import logo28 from "../../assets/img/historicEvents/LogoIYH/1999_28.png";

export const inYourHouseDetail = {
  "in-your-house": {
    id: "in-your-house",
    title: "In Your House",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "in-your-house",
        items: [
          {
            id: "in-your-house-1",
            title: "In Your House",
            description: "1995",
            imgUrl: logo1,
          },
          {
            id: "in-your-house-2",
            title: "In Your House 2",
            description: "The Lumberjacks 1995",
            imgUrl: logo1,
          },
          {
            id: "in-your-house-3",
            title: "In Your House 3",
            description: "3 Belts – One Match! 1995",
            imgUrl: logo1,
          },
          {
            id: "in-your-house-4",
            title: "In Your House 4",
            description: "Great White North 1995",
            imgUrl: logo1,
          },
          {
            id: "in-your-house-5",
            title: "In Your House 5",
            description: "Season's Beatings 1995",
            imgUrl: logo1,
          },
          {
            id: "in-your-house-6",
            title: "In Your House 6",
            description: "Rage in the Cage 1996",
            imgUrl: logo1,
          },
          {
            id: "in-your-house-7",
            title: "In Your House 7",
            description: "Good Friends, Better Enemies 1996",
            imgUrl: logo2,
          },
          {
            id: "in-your-house-8",
            title: "In Your House",
            description: "Beware of Dog: It's Vader Time 1996",
            imgUrl: logo2,
          },
          {
            id: "in-your-house-9",
            title: "In Your House",
            description: "International Incident 1996",
            imgUrl: logo2,
          },
          {
            id: "in-your-house-10",
            title: "In Your House",
            description: "Mind Games 1996",
            imgUrl: logo2,
          },
          {
            id: "in-your-house-11",
            title: "In Your House",
            description: "Buried Alive 1996",
            imgUrl: logo11,
          },
          {
            id: "in-your-house-12",
            title: "In Your House",
            description: "It's Time: Sharpshooter vs. Powerbomb 1996",
            imgUrl: logo12,
          },
          {
            id: "in-your-house-13",
            title: "In Your House",
            description: "Final Four 1997",
            imgUrl: logo13,
          },
          {
            id: "in-your-house-14",
            title: "In Your House",
            description: "Revenge of the 'Taker 1997",
            imgUrl: logo14,
          },
          {
            id: "in-your-house-15",
            title: "In Your House",
            description: "A Cold Day in Hell 1997",
            imgUrl: logo15,
          },
          {
            id: "in-your-house-16",
            title: "In Your House",
            description: "Canadian Stampede 1997",
            imgUrl: logo16,
          },
          {
            id: "in-your-house-17",
            title: "Ground Zero",
            description: "In Your House: That's the Bottom Line... 1997",
            imgUrl: logo17,
          },
          {
            id: "in-your-house-18",
            title: "Badd Blood",
            description: "In Your House 1997",
            imgUrl: logo18,
          },
          {
            id: "in-your-house-19",
            title: "D-Generation X",
            description: "In Your House: Attitude Is Everything 1997",
            imgUrl: logo19,
          },
          {
            id: "in-your-house-20",
            title: "No Way Out of Texas",
            description: "In Your House 1998",
            imgUrl: logo20,
          },
          {
            id: "in-your-house-21",
            title: "Unforgiven",
            description: "In Your House 1998",
            imgUrl: logo21,
          },
          {
            id: "in-your-house-22",
            title: "Over the Edge",
            description: "In Your House 1998",
            imgUrl: logo22,
          },
          {
            id: "in-your-house-23",
            title: "Fully Loaded",
            description: "In Your House 1998",
            imgUrl: logo23,
          },
          {
            id: "in-your-house-24",
            title: "Breakdown",
            description: "In Your House 1998",
            imgUrl: logo24,
          },
          {
            id: "in-your-house-25",
            title: "Judgment Day",
            description: "In Your House 1998",
            imgUrl: logo25,
          },
          {
            id: "in-your-house-26",
            title: "Rock Bottom",
            description: "In Your House 1998",
            imgUrl: logo26,
          },
          {
            id: "in-your-house-27",
            title: "St. Valentine's Day Massacre",
            description: "There's no love lost in this In Your House classic 1999",
            imgUrl: logo27,
          },
          {
            id: "in-your-house-28",
            title: "Backlash",
            description: "In Your House 1999",
            imgUrl: logo28,
          },
        ],
      },
    ],
  },
};
